import { SquareDashedMousePointer, TriangleAlert, X } from "lucide-react";
import React from "react";

import { IgAvatar, IgIconButton, IgTypography } from "@intelligems/ig-theme";
import Box from "@mui/material/Box";
import { Fade, Stack, useTheme } from "@mui/material";

interface ErrorContainerProps {
  title: string;
  description: string;
  buttons?: React.ReactNode;
  onClose?: () => void;
}

export const EmbeddedPreviewError = ({
  title,
  description,
  buttons,
  onClose,
}: ErrorContainerProps) => {
  const theme = useTheme();
  return (
    <Stack
      sx={{
        position: "absolute",
        inset: 0,
        backgroundColor: theme.igPrimitives.gray[50],
        alignItems: "center",
        justifyContent: "center",
        gap: "20px",
        padding: "20px",
      }}
    >
      {onClose && (
        <IgIconButton
          onClick={onClose}
          sx={{ position: "absolute", top: 8, right: 8 }}
        >
          <X size={16} />
        </IgIconButton>
      )}
      <IgAvatar
        variant="circular"
        sx={{
          backgroundColor: theme.igBackgroundColors.tonal.warning,
          width: 50,
          height: 50,
        }}
      >
        <TriangleAlert color={theme.igIconColors.warning} size={24} />
      </IgAvatar>
      <IgTypography sx={{ fontSize: "14px", fontWeight: "600" }}>
        {title}
      </IgTypography>
      <IgTypography sx={{ fontSize: "12px", textAlign: "center" }}>
        {description}
      </IgTypography>
      {buttons && <Stack direction={"row"}>{buttons}</Stack>}
    </Stack>
  );
};
